// Centralized category definitions to ensure consistency across the app

export const CATEGORIES = [
  'Juices & Shakes',
  'Sweets',
  'Namkeen & Snacks',
  'Dairy & Beverages'
];

export const CATEGORY_COLORS = {
  'Juices & Shakes': '#FF6B6B',
  'Sweets': '#FFA500',
  'Namkeen & Snacks': '#4ECDC4',
  'Dairy & Beverages': '#95E1D3'
};

// Normalize category name to handle variations
export const normalizeCategory = (category) => {
  if (!category) return null;
  
  const normalized = category.trim();
  
  // Map common variations to standard names
  const categoryMap = {
    'juice and shake': 'Juices & Shakes',
    'juices and shakes': 'Juices & Shakes',
    'juice & shake': 'Juices & Shakes',
    'juices & shakes': 'Juices & Shakes',
    'sweet': 'Sweets',
    'sweets': 'Sweets',
    'namkeen and snacks': 'Namkeen & Snacks',
    'namkeen & snacks': 'Namkeen & Snacks',
    'dairy and beverages': 'Dairy & Beverages',
    'dairy & beverages': 'Dairy & Beverages'
  };
  
  const lowerCase = normalized.toLowerCase();
  return categoryMap[lowerCase] || normalized;
};
